export default "__VITE_ASSET__edb2b15b__"